import React, { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../dataManagement/uiDb/UiDb";
import { fetchProfile } from "../services/thunks/ProfileThunk";

const RequireTrust: React.FC = () => {
  // We can safely assume the user is authenticated at this point
  // The state will hold the user profile data
  const profile = useSelector((state: RootState) => state.profile);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        if (profile && profile.data && profile.data.phone.length > 2) {
        } else {
          dispatch(fetchProfile());
        }
      } catch (error) {
        console.error("Failed to fetch profile:", error);
        // Optionally handle error - maybe redirect to error page or show notification
      }
    };
    fetchProfileData();
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div>
      {profile && profile.data ? (
        <Outlet />
      ) : (
        <Navigate to="/validateuser" replace />
      )}
    </div>
  );
};

export default RequireTrust;
